import $ from 'jquery'

const $body = $(document.body)
const $splashScreen = $('.splash-screen')

if ($splashScreen.length) {
    if ($splashScreen.is(':visible')) {
        $body.addClass('overflow-hidden')
    }

    $(window).load(() => {
        $splashScreen.addClass('fading')
        setTimeout(() => {
            $splashScreen.addClass('faded')
            $body.removeClass('overflow-hidden')
        }, 500)
    })
}